import Cleave from "cleave.js/react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { 
    myAxios, 
    MyFormData, 
    objAscSort
} from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
//--------------------------------------------------------------------------------------------
export default function OutsideServiceDivisionForm({
    closeIt, 
    setCurrentPage, 
    divisionsPerPage, 
}){
    const divisions = useMyStore(state => state.outsideserviceLocatorDivisions);
    const setDivisions = useMyStore(state => state.setOutsideserviceLocatorDivisions);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    //--------------------------------------------------------------------------------------------
    const handleSumbit = async e => {
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        //--------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("outside/divisions/createDivision.php", formData);
        setShowLoader(false);
        if(!res) return;
        //--------------------------------------------------------
        const obj = {};
        for(const pair of formData.entries()){
            if(["email", "password", "version", "userName", ""].includes(pair[0])) continue;
            obj[pair[0]] = pair[1];
        }
        setDivisions([...divisions.data, obj].sort((a, b) => objAscSort(a, b, "division"))); // here
        closeIt();
        setCurrentPage(Math.ceil((divisions.data.length + 1) / divisionsPerPage));
    }
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {"Outside Division Form"}
            width = {"40rem"}
            handleFormSubmit = {handleSumbit}
            actionKey = {"Submit"}
        >
            <div className = "d-flex align-items-center mt-2">
                    <label htmlFor = "divisionInput" className = "font-weight-bold">Division:</label>
                    <input
                        id = "divisionInput"
                        required
                        type = "text"
                        className = "form-control flex-grow-1 ml-3"
                        name = "division"
                        defaultValue = {""}
                    />
                </div>
            <div className = "d-flex align-items-center mt-2">
                <label htmlFor = "supervisorNameInput" className = "font-weight-bold mr-3">Supervisor Name:</label>
                <input
                    id = "supervisorNameInput"
                    type = "text"
                    className = "form-control flex-grow-1 ml-3"
                    name = "supervisorName"
                    defaultValue = {""}
                />
            </div>
            <div className = "d-flex align-items-center mt-2">
                <label htmlFor = "supervisorEmailInput" className = "font-weight-bold mr-3">Supervisor Email:</label>
                <input
                    id = "supervisorEmailInput"
                    type = "email"
                    className = "form-control flex-grow-1 ml-3"
                    name = "supervisorEmail"
                    defaultValue = {""}
                />
            </div>
            <div className = "d-flex align-items-center mt-2">
                <label htmlFor = "roleInput" className = "font-weight-bold mb-0">Role:</label>
                <input
                    id = "roleInput" 
                    type = "text"
                    className = "form-control flex-grow-1 ml-3"
                    name = "role"
                    defaultValue = {""}
                />
            </div>
            <div className = "d-flex align-items-center mt-2">
                <label htmlFor = "supervisorPhoneInput" className = "font-weight-bold mb-0">Supervisor Phone:</label>
                <Cleave
                    id = "supervisorPhoneInput"
                    className = "form-control flex-grow-1 ml-3"
                    name = "supervisorPhone"
                    pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                    options = {{
                        blocks: [3, 3, 4],
                        delimiter: "-",
                        numericOnly: true,
                    }}
                    defaultValue = {""}
                />
            </div>
            <div className = "d-flex align-items-center mt-2 mb-2">
                <label htmlFor = "regionInput" className = "font-weight-bold mb-0">Region:</label>
                <input
                    id = "regionInput"
                    type = "text"
                    className = "form-control flex-grow-1 ml-3"
                    name = "region"
                    defaultValue = {""}
                />
            </div>
        </Modal>
    )
}